import React from "react";
import Modal from "../../../components/modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning } from "@fortawesome/free-solid-svg-icons";

export const SubmitModal = ({ open, onClose, onConfirm }) => {
    return (
        <Modal
            cssClass="advanced-filters-modal"
            show={open}
            onClose={onClose}
        >
            <div className="flex p-16">
                <div className="m-t-20 m-r-8 -warning">
                    <FontAwesomeIcon
                        size={"lg"}
                        className="txt-error"
                        icon={faWarning}
                    />
                </div>
                <div className="flex-column">
                    <h2>Changing the SLA Terms & Conditions will impact all Clients using this SLA Group Name.</h2>
                    <p>Are you sure you want to proceed?</p>
                </div>
            </div>
            <div className="border-top button-group -right m-t-16 p-l-12 p-r-12">
                <button
                    type="button"
                    className="button"
                    onClick={onClose}
                >
                    Cancel
                </button>
                <button
                    type="button"
                    className="button -primary"
                    onClick={onConfirm}
                >
                    Confirm
                </button>
            </div>
        </Modal>
    );
};
